export const autoLockRuleCreateModeId = 'create-auto-lock-rule';

export const AUTO_LOCK_RULES_PAGE_TITLE = 'Auto-lock Rules';

export { HIDDEN_FIELD_PREFIX } from 'store/loanApplications/constants/lockedFields.constants';

export const VisibilityMode = {
  DISABLED: 'disabled',
  HIDDEN: 'hidden',
};

export const visibilityModeOptions = [
  { value: VisibilityMode.DISABLED, label: 'Disabled' },
  { value: VisibilityMode.HIDDEN, label: 'Hidden' },
];
